<template>
  <div class="jadlog-receipt p-1 page-break-inside-avoid">
    <jadlog-comprovante-item :rows="rows" :columns="columns" />

    <div class="h-8 relative mb-8 border-b border-dashed border-black">
      <svg class="w-3 h-7 absolute -bottom-2 left-6 -rotate-90">
        <use xlink:href="/images/svg-symbols.svg#half-scissors"></use>
      </svg>
    </div>

    <jadlog-comprovante-item :rows="rows" :columns="columns" />
  </div>
</template>

<script>
import JadlogComprovanteItem from './JadlogComprovanteItem.vue'

export default {
  components: {
    JadlogComprovanteItem,
  },
  data() {
    return {
      rows: 4,
      columns: 2,
    }
  },
};
</script>

<style lang="stylus" scoped>
@media print
  .jadlog-receipt
    padding 5mm
</style>